export enum ProfileSteps {
  Details,
  OTP,
  Update,
}

export enum UpdateProfileSteps {
  PersonalDetails,
  PhysicalAddress,
  PostalAddress,
  Notice,
}

export enum DataRequestSteps {
  Initial,
  Success,
  Fail,
}

export enum OtpSteps {
  Form,
  AltMethods,
  Loading,
  Success,
  Error
}

export enum OtpAltMethods {
  SMS = 'Mobile',
  Email = 'Email',
}
